import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';

import { withRouter } from 'react-router';

const getRouter = type => compose(
  withRouter,
  mapProps(({ history, location, match, ...props }) => {
    if (type === 'params') {
      props.params = match.params;
    }

    return props;
  }),
);

export const withParams = getRouter('params');



// WEBPACK FOOTER //
// ./src/client/js/view/hocs/router.js